// 1. Dependencies
import { nodeConfig } from '@scripts/mixins';
import { modulesLoaded } from '@scripts/helpers/modules-loader';

// 2. Configuration
export const NAMESPACE = 'whats-on-calendar';
export const DEFAULT_SELECTOR = '[data-js-whats-on-calendar]';
export const DEFAULT_SETTINGS = {};

// 3. Module
export class WhatsOnCalendar {
	/** @param {HTMLElement} node */
	constructor(node, config) {
		this.elNode = node;
		this.carouselDates = Array.from(this.elNode.querySelectorAll('[data-js-whats-on-calendar-date]'));
		this.elSubmit = this.elNode.querySelector('[data-js-whats-on-calendar-filter-submit]');

		this.config = config;
		this.carouselInstance = null;
		this.calendarInstance = null;

		this.moduleInstanceLookup = {};
	}

	moveCarousel(event) {
		if (!this.moduleInstanceLookup) return;

		if (!this.carouselInstance) {
			this.carouselInstance = this.moduleInstanceLookup
				.getModule('embla-carousel')
				?.get(this.elNode.querySelector('[data-js-embla-carousel]'));
		}

		if (!this.calendarInstance) {
			this.calendarInstance = this.moduleInstanceLookup
				.getModule('calendar')
				?.get(this.elNode.querySelector('[data-js-calendar]'));
		}

		if (!this.carouselInstance || !this.calendarInstance) return;

		const date = this.calendarInstance.selectedDate;
		if (!date) return;

		const targetSlide = this.carouselDates.findIndex((slide) => slide.dataset.jsWhatsOnCalendarDate === date);
		if (targetSlide === -1) return;

		this.carouselInstance?.goToSlide(targetSlide);
	}

	bindUI() {
		this.elSubmit.addEventListener('click', this.moveCarousel.bind(this));
	}

	init() {
		this.bindUI();
		modulesLoaded.then((instanceLookup) => {
			this.moduleInstanceLookup = instanceLookup;
		});
	}
}

// 4. Factory Function
export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	const listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		const config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		const module = new WhatsOnCalendar(node, config);

		module.init();

		return module;
	});
}
